import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from 'components/AppIcon';
import Logo from '../../assets/images/logo.png';
import { registerDeviceToken } from '../../utils/firebase';
import api from '../../utils/api';
import { APP_VERSION } from '../../config/version';

function LoginIndex() {
  const navigate = useNavigate();

  const [phone, setPhone] = useState('');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loginType, setLoginType] = useState('admin');
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;

    setIsSubmitting(true);
    setError('');
    try {
      const { data } = loginType === 'admin'
        ? await api.post('/admin-auth/login-admin', { username, password })
        : await api.post('/admin-auth/login-phone', { phone });
      localStorage.setItem('token', data.token);
      registerDeviceToken().catch(() => {});
      navigate(data.role === 'employee' ? '/booking-management' : '/salon-dashboard');
    } catch (err) {
      const serverMessage = err?.response?.data?.error;
      setError(serverMessage || (loginType === 'admin' ? 'نام کاربری یا رمز عبور اشتباه است' : 'این شماره برای ورود مجاز نیست'));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div
      dir="rtl"
      className="flex h-screen flex-col justify-center px-6 py-12 lg:px-8 bg-background">
      <div className="sm:mx-auto sm:w-full sm:max-w-sm p-3">
        <div className="flex justify-center">
          <div className="flex h-28 w-64 items-center justify-center rounded-2xl bg-[#117d77] px-5 py-4 shadow-lg ring-1 ring-black/10">
          <img
            src={Logo}
            alt="Morjan"
            className="h-auto w-full object-contain"
          />
          </div>
        </div>
        <h2 className="mt-8 text-center text-2xl font-bold tracking-tight text-foreground">
          ورود به پنل مدیریت
        </h2>
        <p className="mt-2 text-center text-sm text-muted-foreground">
          نسخه تحت وب و موبایل ادمین
        </p>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-sm">
        <form onSubmit={handleSubmit} className="space-y-5">
          <div className="grid grid-cols-2 gap-2 rounded-xl bg-muted p-1">
            <button type="button" onClick={() => { setLoginType('admin'); setError(''); }} className={`rounded-lg py-2 text-sm ${loginType === 'admin' ? 'bg-card font-bold shadow-sm' : 'text-muted-foreground'}`}>ورود مدیر</button>
            <button type="button" onClick={() => { setLoginType('employee'); setError(''); }} className={`rounded-lg py-2 text-sm ${loginType === 'employee' ? 'bg-card font-bold shadow-sm' : 'text-muted-foreground'}`}>ورود کارمند</button>
          </div>
          {/* Username */}
          {loginType === 'admin' ? <>
          <div>
            <label htmlFor="username" className="block text-sm font-medium text-foreground">نام کاربری یا ایمیل</label>
            <input id="username" name="username" type="text" value={username} onChange={(e) => setUsername(e.target.value)} required className="mt-2 block w-full rounded-xl bg-muted px-3 py-3 text-base text-foreground outline-none ring-1 ring-inset ring-border focus:ring-2 focus:ring-primary sm:text-sm" placeholder="admin" />
          </div>
          <div>
            <label htmlFor="password" className="block text-sm font-medium text-foreground">رمز عبور</label>
            <input id="password" name="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="mt-2 block w-full rounded-xl bg-muted px-3 py-3 text-base text-foreground outline-none ring-1 ring-inset ring-border focus:ring-2 focus:ring-primary sm:text-sm" placeholder="••••" />
          </div>
          </> : <div>
            <label
              htmlFor="phone"
              className="block text-sm font-medium text-foreground">
              شماره موبایل کارمند
            </label>
            <div className="relative mt-2">
              <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3 text-muted-foreground">
                <Icon name="User" size={18} />
              </div>
              <input
                id="phone"
                name="phone"
                type="tel"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                required
                className="block w-full rounded-xl bg-muted px-3 py-3 pr-10 text-base text-foreground outline-none ring-1 ring-inset ring-border placeholder:text-muted-foreground focus:ring-2 focus:ring-primary sm:text-sm"
                placeholder="09121234567"
              />
            </div>
          </div>}

          {/* Error */}
          {error && (
            <p role="alert" className="text-error text-sm text-center bg-error/10 py-2 rounded-lg">
              {error}
            </p>
          )}

          {isSubmitting && (
            <p role="status" aria-live="polite" className="text-center text-xs text-muted-foreground">
              در حال بررسی اطلاعات ورود...
            </p>
          )}

          {/* Submit */}
          <div>
            <button
              type="submit"
              disabled={isSubmitting}
              aria-busy={isSubmitting}
              className="flex w-full items-center justify-center gap-2 rounded-xl bg-primary px-3 py-3 text-sm font-semibold text-primary-foreground shadow-sm transition-colors hover:bg-primary/90 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary active:scale-[0.98] disabled:cursor-wait disabled:opacity-70 disabled:hover:bg-primary">
              {isSubmitting && (
                <span aria-hidden="true" className="h-4 w-4 animate-spin rounded-full border-2 border-primary-foreground/35 border-t-primary-foreground" />
              )}
              {isSubmitting ? 'در حال ورود...' : 'ورود به داشبورد'}
            </button>
          </div>
        </form>
      </div>
      <p className="mt-8 text-center text-xs text-muted-foreground">
        نسخه {APP_VERSION}
      </p>
    </div>
  );
}

export default LoginIndex;
